import { BASE_SERVICE_URL } from '../lib/constants'


const listTypes = async (): Promise<string[]> => {
    try {
        const listResult = await fetch(BASE_SERVICE_URL + `/models/list-types`, {
            credentials: 'same-origin',
        }).then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                var error = new Error(response.statusText);
                error.response = response;
                throw error;
            }
        }) as string[]
        return listResult;
    } catch (error) {
        return []
    }
}



export default listTypes